import Utils from '@/utils/default'
import collection from './collection'

export default {
  state: {
    ...collection.state,
    collectionPerPage: {}
  },
  getters: {
    ...collection.getters,
    pages: state => state.collectionPerPage
  },
  mutations: {
    ...collection.mutations,
    collectionForPageFetched: (state, { collectionForPage, pagination, scope }) => {
      state.collectionPerPage = {
        ...state.collectionPerPage,
        [Utils.dataToUrlString(scope)]: {
          list: collectionForPage.map(e => e.id || e._id),
          pagination
        }
      }
      collection.mutations.updateCollection(state, { collection: collectionForPage })
    },
    appendItem: (state, { item, scope }) => {
      const key = Utils.dataToUrlString(scope)
      const existingPagination = state.collectionPerPage[key] || { list: [], pagination: {} }
      state.collectionPerPage = {
        ...state.collectionPerPage,
        [key]: {
          list: [
            ...existingPagination.list,
            (item.id || item._id)
          ]
            .filter((value, index, self) => self.indexOf(value) === index),
          pagination: existingPagination.pagination
        }
      }
      collection.mutations.updateCollection(state, { collection: [item] })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/helpers/collectionPerPage.js